"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APText = void 0;
var react_1 = __importDefault(require("react"));
var dialogTextVariants = {
    dialogTitle: { letterSpacing: "0.5px", lineHeight: "22px", fontSize: "18px", fontWeight: 700, /* textAlign: "center", */ color: "#333333", textTransform: 'uppercase' },
    dialogDescription: { letterSpacing: "0.5px", lineHeight: "16px", fontSize: "15px", },
};
var cardTextVariants = {
    cardTitleLarge: { fontSize: "15px", lineHeight: "18px", fontWeight: 700, color: "#333", letterSpacing: "0.8px" },
    cardTitle: { /* fontSize: "13px", */ lineHeight: "13px", letterSpacing: "0.89px", fontWeight: 700, color: "#333", },
    cardSubtitle: { /*fontSize: "14px",*/ lineHeight: "14px", letterSpacing: "0.25px", fontWeight: 600, color: "#4f4f4f" },
    cardSubText: { fontSize: "12px", lineHeight: "12px", fontWeight: 600, color: "#828282" },
};
var commonTextVariants = {
    normal: { /* fontSize: "13px",  */ lineHeight: "18px", },
    maintext: { /* fontSize: "14px", */ fontWeight: 600 },
    subtext: { /* fontSize: "13px", */ color: "#828282" },
};
var TextVariants = __assign(__assign(__assign({}, dialogTextVariants), cardTextVariants), commonTextVariants);
function APText(_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'normal' : _b, style = _a.style, colored = _a.colored, onClick = _a.onClick, ellipsis = _a.ellipsis, strike = _a.strike;
    var mStyle = {};
    if (ellipsis) {
        mStyle.overflow = 'hidden';
        mStyle.textOverflow = 'ellipsis';
        mStyle.whiteSpace = 'nowrap';
    }
    if (colored !== undefined) {
        if (colored > 0) {
            mStyle.color = '#12ab00';
        }
        if (colored < 0) {
            mStyle.color = '#d91c00';
        }
    }
    if (onClick) {
        mStyle.cursor = "pointer";
    }
    return (react_1.default.createElement("div", { style: __assign(__assign(__assign({}, TextVariants[variant]), style), mStyle), onClick: onClick }, strike
        ? react_1.default.createElement("del", null, children)
        : children));
}
exports.APText = APText;
